module.exports = __webpack_public_path__ + "img/boating_school.83aadb2e.jpg";